import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      width: 'auto',
      height: 'inherit',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      // border: '2px solid black',
    },
    root: {
      // border: '2px solid red',
      // height: '90%',
      marginTop: '40px',
      marginBottom: '20px',
      opacity: 1,
      // '@media (max-height: 800px), (max-width: 1400px)': {
      //   // height: 'inherit',
      //   marginTop: '40px',
      // },
    },
  }),
  { index: 1 },
)

export { useStyles }
